import {
  extractSearchParams,
  getMobileOS,
  redirectToAppIfInstalled,
  redirectToStore, shouldRedirectToApp,
  shouldRedirectToStore,
} from '~/utils/store-redirect';

export default function ({ app, route }) {
  // Check if we're on mobile
  const os = getMobileOS();
  // If not on mobile, do nothing
  if (!os) return;

  // Get full path with query params
  const fullPath = window.location.href;
  // Get path without language prefix
  const path = route.path;
  const locales = app.i18n.locales.map(locale => locale.code);
  const localeRegex = new RegExp(`^/(${locales.join('|')})/`);
  const pathWithoutLocale = path.replace(localeRegex, '/');
  // Extract query parameters
  const searchParams = extractSearchParams(fullPath);

  if (shouldRedirectToApp(pathWithoutLocale)) {
    // force deeplink to avoid error on instagram & facebook
    redirectToAppIfInstalled(os, pathWithoutLocale, searchParams);
  }

  // Check if we should redirect
  if (shouldRedirectToStore(pathWithoutLocale, searchParams)) {
    setTimeout(() => {
      if (document.hasFocus()) {
        redirectToStore(os);
      }
    }, 10000);
  }
}
